import { render, staticRenderFns } from "./CatalogueTile.vue?vue&type=template&id=5f75946c&"
import script from "./CatalogueTile.vue?vue&type=script&lang=js&"
export * from "./CatalogueTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CatalogueTile.vue"
export default component.exports